<template>
    <div class="flex flex-col dark:text-white">
        <div class="my-5">
            <router-link :to="{ name: 'fdic.submissions' }" class="text-sm text-indigo-500 hover:underline">
                &larr; Voltar para listagem
            </router-link>
            <h1 class="mt-1 text-2xl font-semibold">Envio em Lote FDIC</h1>
            <p class="text-sm text-gray-500">
                Informe os IDs de usuários (um por linha). O Aegis buscará os dados de cadastro e contas bancárias e enviará ao FDIC em lote assíncrono.
            </p>
        </div>

        <form @submit.prevent="submit" class="space-y-4">
            <textarea
                v-model="userIdsRaw"
                rows="10"
                placeholder="123&#10;456&#10;789"
                class="w-full rounded-lg border border-gray-300 bg-gray-50 p-3 font-mono text-sm dark:border-gray-600 dark:bg-gray-700 dark:text-white"
                required
            ></textarea>

            <div class="flex items-center justify-end gap-3">
                <span v-if="userIds.length" class="text-sm text-gray-500">
                    {{ userIds.length }} conta(s) selecionada(s)
                </span>
                <button
                    type="submit"
                    :disabled="submitting || !userIds.length"
                    class="inline-flex items-center rounded-md bg-indigo-500 px-4 py-2 text-sm font-semibold text-white shadow hover:bg-indigo-400 disabled:opacity-50"
                >
                    {{ submitting ? 'Enviando...' : 'Disparar lote' }}
                </button>
            </div>
        </form>

        <div v-if="ticket" class="mt-6 rounded-lg border border-green-300 bg-green-50 p-4 dark:bg-green-900/20">
            <h2 class="font-semibold text-green-700 dark:text-green-300">Lote disparado</h2>
            <p class="mt-1 text-sm">Ticket: <code class="rounded bg-white px-2 py-0.5 dark:bg-gray-900">{{ ticket }}</code></p>
            <p v-if="!ticketStatus" class="mt-1 text-sm text-gray-500">consultando status…</p>
            <div v-else class="mt-2 space-y-1 text-sm">
                <p><strong>{{ ticketStatus.count }}</strong> cedente(s) no lote</p>
                <ul class="ml-4 list-disc">
                    <li v-for="(n, status) in ticketStatus.byStatus" :key="status">
                        {{ status }}: <strong>{{ n }}</strong>
                    </li>
                </ul>
                <p class="text-xs text-gray-500">
                    <router-link :to="{ name: 'fdic.submissions', query: { ticket } }" class="text-indigo-500 underline">
                        ver na listagem →
                    </router-link>
                </p>
            </div>
            <p class="mt-2 text-xs text-gray-500">Atualização automática a cada 10s. <button @click.prevent="stopPolling" class="text-indigo-500 underline">parar</button></p>
        </div>
    </div>
</template>

<script>
export default {
    name: "FdicBatchSubmit",
    data() {
        return {
            userIdsRaw: "",
            submitting: false,
            ticket: null,
            ticketStatus: null,
            pollInterval: null,
        };
    },
    computed: {
        userIds() {
            return this.userIdsRaw
                .split(/\s+/)
                .map((s) => parseInt(s, 10))
                .filter((n) => !isNaN(n));
        },
    },
    beforeUnmount() {
        this.stopPolling();
    },
    methods: {
        async submit() {
            this.submitting = true;
            this.ticket = null;
            this.ticketStatus = null;
            try {
                const { data } = await window.axios.post("/api/fdic/submissions/batch", {
                    user_ids: this.userIds,
                });
                this.ticket = data.ticket;
                if (this.ticket) {
                    this.pollTicket();
                }
            } finally {
                this.submitting = false;
            }
        },
        async pollTicket() {
            this.stopPolling();
            this.pollInterval = setInterval(async () => {
                try {
                    // Pede ao backend pra reconciliar o status na BDR antes de listar.
                    await window.axios.post(`/api/fdic/submissions/ticket/${this.ticket}/reconcile`).catch(() => {});

                    const { data } = await window.axios.get("/api/fdic/submissions", {
                        params: { ticket: this.ticket, per_page: 50 },
                    });
                    const items = data?.data ?? [];
                    this.ticketStatus = {
                        count: items.length,
                        byStatus: items.reduce((acc, it) => {
                            acc[it.status] = (acc[it.status] || 0) + 1;
                            return acc;
                        }, {}),
                    };
                    const pending = items.some(it => ['pending', 'processing'].includes(it.status));
                    if (!pending) {
                        this.stopPolling();
                    }
                } catch (e) {
                    this.stopPolling();
                }
            }, 10000);
        },
        stopPolling() {
            if (this.pollInterval) {
                clearInterval(this.pollInterval);
                this.pollInterval = null;
            }
        },
    },
};
</script>
